<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align:center;">
      {{ $t('common.confirmDelete') }}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteMallUser">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMallUser } from '@/api/user/mallUserApi'

export default {
  name: 'DeleteMallUser',
  data() {
    return {
      dialogVisible: false,
      currentUser: null
    }
  },
  methods: {
    open(user) {
      this.currentUser = user
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async deleteMallUser() {
      try {
        const res = await deleteMallUser(this.currentUser)
        if (res.code === 0) {
          this.$message.success(this.$t('deleteMallUser.success'))
          this.$emit('refresh')
          this.closeDialog()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除用户失败:', error)
        this.$message.error(this.$t('deleteMallUser.error'))
      }
    }
  }
}
</script>